type SourceTheme = "naati" | "notary" | "pcc" | "moj" | "sworn" | "lgz" | "visa" | "law" | "accounting" | "corporate";

const SOURCES: Record<
  SourceTheme,
  Array<{ label: string; description: string; href: string }>
> = {
  accounting: [
    { label: "กรมสรรพากร", description: "ประมวลรัษฎากร กำหนดยื่นแบบภาษี ภ.ง.ด. และ ภ.พ.30 และการยื่นภาษีทางอินเทอร์เน็ต", href: "https://www.rd.go.th/" },
    { label: "กรมพัฒนาธุรกิจการค้า", description: "การส่งงบการเงินประจำปี (ส.บ.ช.3) และบัญชีรายชื่อผู้ถือหุ้น (บอจ.5)", href: "https://www.dbd.go.th/" },
    { label: "สำนักงานประกันสังคม", description: "การขึ้นทะเบียนนายจ้างและการนำส่งเงินสมทบรายเดือนของลูกจ้าง", href: "https://www.sso.go.th/" },
    { label: "สภาวิชาชีพบัญชี", description: "มาตรฐานการรายงานทางการเงินที่ใช้ในประเทศไทย และการตรวจสอบผู้สอบบัญชีรับอนุญาต", href: "https://www.tfac.or.th/" },
  ],
  corporate: [
    { label: "กรมพัฒนาธุรกิจการค้า", description: "ตรวจหลักเกณฑ์จองชื่อ จดทะเบียนจัดตั้ง และแก้ไขรายการของนิติบุคคล", href: "https://www.dbd.go.th/" },
    { label: "กรมสรรพากร", description: "ตรวจการจดทะเบียนภาษีมูลค่าเพิ่ม เลขประจำตัวผู้เสียภาษี และหน้าที่ทางภาษีหลังจัดตั้ง", href: "https://www.rd.go.th/" },
    { label: "สำนักงานคณะกรรมการส่งเสริมการลงทุน", description: "ตรวจประเภทกิจการ เงื่อนไข และสิทธิประโยชน์การส่งเสริมการลงทุนจากประกาศปัจจุบัน", href: "https://www.boi.go.th/" },
    { label: "สำนักงานประกันสังคม", description: "ตรวจหน้าที่ขึ้นทะเบียนนายจ้างและผู้ประกันตนเมื่อบริษัทเริ่มจ้างงาน", href: "https://www.sso.go.th/" },
  ],
  law: [
    { label: "สภาทนายความในพระบรมราชูปถัมภ์", description: "ตรวจสอบสถานะใบอนุญาตว่าความของทนายความ และข้อบังคับว่าด้วยมรรยาททนายความ", href: "https://www.lawyerscouncil.or.th/" },
    { label: "สำนักงานศาลยุติธรรม", description: "ค้นหาศาลที่มีเขตอำนาจ ตรวจนัดความ และค่าธรรมเนียมศาล", href: "https://www.coj.go.th/" },
    { label: "กรมบังคับคดี", description: "ขั้นตอนบังคับคดีหลังมีคำพิพากษา การยึด อายัด และการขายทอดตลาดทรัพย์สิน", href: "https://www.led.go.th/" },
    { label: "กรมพัฒนาธุรกิจการค้า", description: "ตรวจข้อมูลนิติบุคคล ผู้มีอำนาจลงนาม และการจดทะเบียนเปลี่ยนแปลงของบริษัท", href: "https://www.dbd.go.th/" },
    { label: "กรมที่ดิน", description: "ขั้นตอนจดทะเบียนสิทธิและนิติกรรมเกี่ยวกับที่ดิน รวมถึงการรับมรดกที่ดิน", href: "https://www.dol.go.th/" },
    { label: "กรมทรัพย์สินทางปัญญา", description: "สืบค้นและยื่นจดทะเบียนเครื่องหมายการค้า สิทธิบัตร และแจ้งข้อมูลลิขสิทธิ์", href: "https://www.ipthailand.go.th/" },
  ],
  naati: [
    {
      label: "NAATI",
      description: "ตรวจสอบประเภทการรับรองและค้นหาผู้ประกอบวิชาชีพจากหน่วยงาน NAATI โดยตรง",
      href: "https://www.naati.com.au/",
    },
    {
      label: "Department of Home Affairs — Australia",
      description: "ตรวจเงื่อนไขเอกสารและการแปลสำหรับเรื่องตรวจคนเข้าเมืองของออสเตรเลีย",
      href: "https://immi.homeaffairs.gov.au/",
    },
  ],
  notary: [
    {
      label: "สภาทนายความในพระบรมราชูปถัมภ์",
      description: "ตรวจสอบข้อมูลเกี่ยวกับทนายความและประกาศจากสภาทนายความ",
      href: "https://www.lawyerscouncil.or.th/",
    },
    {
      label: "กรมการกงสุล กระทรวงการต่างประเทศ",
      description: "ตรวจขั้นตอนรับรองนิติกรณ์สำหรับเอกสารที่จะนำไปใช้ต่างประเทศ",
      href: "https://consular.mfa.go.th/",
    },
  ],
  pcc: [
    {
      label: "ศูนย์บริการออกหนังสือรับรองความประพฤติ",
      description: "ตรวจคุณสมบัติ เอกสาร และช่องทางดำเนินการจากสำนักงานตำรวจแห่งชาติ",
      href: "https://pcscenter.sbpolice.go.th/",
    },
    {
      label: "กรมการกงสุล กระทรวงการต่างประเทศ",
      description: "ตรวจขั้นตอนรับรองนิติกรณ์เมื่อหน่วยงานปลายทางกำหนดให้รับรองเอกสารต่อ",
      href: "https://consular.mfa.go.th/",
    },
  ],
  moj: [
    {
      label: "กระทรวงยุติธรรม",
      description: "ตรวจข่าว ประกาศ และบริการประชาชนของกระทรวงยุติธรรม",
      href: "https://www.moj.go.th/",
    },
    {
      label: "ศาลยุติธรรม",
      description: "ตรวจข้อมูลศาล ขั้นตอนคดี และบริการประชาชนจากหน่วยงานเจ้าของเรื่อง",
      href: "https://www.coj.go.th/",
    },
  ],
  sworn: [
    {
      label: "กรมการกงสุล กระทรวงการต่างประเทศ",
      description: "ตรวจขั้นตอนรับรองนิติกรณ์เอกสารไทยก่อนยื่นต่อหน่วยงานต่างประเทศ",
      href: "https://consular.mfa.go.th/",
    },
    {
      label: "สถานทูตและสถานกงสุลต่างประเทศในไทย",
      description: "ค้นหาหน่วยงานปลายทางเพื่อยืนยันรูปแบบคำแปลและลำดับการรับรองล่าสุด",
      href: "https://www.mfa.go.th/th/page/diplomatic-and-consular-list",
    },
  ],
  lgz: [
    {
      label: "กรมการกงสุล กระทรวงการต่างประเทศ",
      description: "ตรวจประเภทเอกสาร ขั้นตอน และประกาศล่าสุดเกี่ยวกับการรับรองนิติกรณ์",
      href: "https://consular.mfa.go.th/",
    },
    {
      label: "HCCH — Apostille Section",
      description: "ตรวจสถานะภาคีและข้อมูลทางการของอนุสัญญา Apostille จาก HCCH",
      href: "https://www.hcch.net/en/instruments/conventions/specialised-sections/apostille",
    },
  ],
  visa: [
    {
      label: "กรมการกงสุล กระทรวงการต่างประเทศ",
      description: "ตรวจข้อมูลการตรวจลงตราไทยและประกาศด้านกงสุลจากหน่วยงานรัฐ",
      href: "https://consular.mfa.go.th/",
    },
    {
      label: "สำนักงานตรวจคนเข้าเมือง",
      description: "ตรวจข้อมูลการอยู่ต่อและบริการตรวจคนเข้าเมืองจากหน่วยงานเจ้าของเรื่อง",
      href: "https://www.immigration.go.th/",
    },
  ],
};

export function OfficialServiceSources({ theme }: { theme: SourceTheme }) {
  return (
    <section aria-labelledby={`official-sources-${theme}`} className="mt-10 border-t border-border pt-8">
      <h2 id={`official-sources-${theme}`} className="text-xl font-semibold">
        แหล่งข้อมูลทางการสำหรับตรวจสอบก่อนดำเนินการ
      </h2>
      <p className="text-sm text-muted-foreground">
        เงื่อนไขขึ้นกับประเภทเอกสาร ประเทศ และหน่วยงานผู้รับ โปรดยืนยันข้อกำหนดล่าสุดกับหน่วยงานเจ้าของเรื่องอีกครั้ง
      </p>
      <ul className="grid gap-4 md:grid-cols-2">
        {SOURCES[theme].map((source) => (
          <li key={source.href} className="rounded-md border border-border p-4">
            <a
              href={source.href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-primary hover:underline"
            >
              {source.label} <span aria-hidden="true">↗</span>
            </a>
            <p className="mt-1 text-sm text-muted-foreground">{source.description}</p>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-muted-foreground">
        ผู้จัดทำ: กองบรรณาธิการ Thai Notary Law · ตรวจข้อกำหนดล่าสุดจากลิงก์ของหน่วยงานก่อนดำเนินการ · ข้อมูลนี้เป็นแนวทางทั่วไป ไม่ใช่คำรับรองผลของหน่วยงาน
      </p>
    </section>
  );
}